<template>
  <div class="home">
    <header>
      <h1> Welcome to Sporte </h1>

      <div style="margin-bottom: 32px">
        <el-button
          type="primary"
          @click="goToLogin">
            Login
            <i class="el-icon-arrow-right el-el-icon-right"></i>
        </el-button>
      </div>

      <div>
        <el-button
          type="primary"
          @click="goToBooking">
            Book Now
            <i class="el-icon-arrow-right el-el-icon-right"></i>
        </el-button>
      </div>

    </header>
  </div>
</template>

<script>
export default {
  name: 'home',
  data () {
    return {
    }
  },
  methods: {
    goToBooking() {
      this.$router.push({ path: '/booking'} );
    },
    goToLogin() {
      this.$router.push({ path: '/login'} );
    }
  }
}
</script>

<style>
  .home header { 
    height: 600px;
    background: url('http://sporte.io/images/Backgrounds/TennisCenter.jpg');
  }

  .home h1 {
    color: white;
    font-size: 300%;
    padding: 25% 0;
  }
</style>



// WEBPACK FOOTER //
// Home.vue?05067ae8